import { useLayoutEffect, useRef } from "react";

// Copies <th> labels onto cells so the table can stack as cards on small screens.
export default function StackTable({ children, className = "", ...rest }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const t = ref.current;
    const label = () => {
      const heads = [...t.querySelectorAll("thead th")].map((th) => th.textContent.trim());
      t.querySelectorAll("tbody tr").forEach((tr) => {
        let i = 0;
        [...tr.children].forEach((td) => {
          if (td.colSpan === 1 && heads[i] && td.getAttribute("data-label") !== heads[i]) td.setAttribute("data-label", heads[i]);
          i += td.colSpan || 1;
        });
      });
    };
    label();
    const mo = new MutationObserver(label);
    mo.observe(t, { childList: true, subtree: true, characterData: true });
    return () => mo.disconnect();
  }, []);
  return (
    <table ref={ref} className={`stack ${className}`.trim()} {...rest}>
      {children}
    </table>
  );
}
